export default "__VITE_ASSET__C8p5AeJA__"